import { Author } from "./content";

export function getDisplayedAuthor(content: { publisher?: Author; author?: Author }): Author {
	return content.publisher ?? (content.author as Author);
}
